import React from 'react';
import { useRouter } from 'next/router';

import styled from 'styled-components';
import TitleMask from '@/components/Common/Layout/TitleMask';
import CommunityComponent from '@/components/Community';

import { useGetPosts } from '@/hooks/community/useGetPosts';

interface typeT {
  type?: 'notice' | 'free' | 'event';
}

// style
const PostCreateLayout = styled.div`
  table thead tr th:nth-of-type(3) {
    text-align: left;
  }

  table tbody tr td:nth-of-type(3) {
    text-align: left;
  }
`;

function PostType() {
  const router = useRouter();
  const query = router.isReady ? router.query : undefined;
  const { type } = (router.isReady ? router.query : '') as typeT;
  const [postList] = useGetPosts({
    type,
    query,
  });

  return (
    <TitleMask title={type && POST_TYPE[type].title}>
      <PostCreateLayout>
        {postList.data && !postList.isLoading && (
          <CommunityComponent
            posts={postList.data}
            pathname={type}
            query={query}
          />
        )}
      </PostCreateLayout>
    </TitleMask>
  );
}

export default PostType;

const POST_TYPE = {
  notice: {
    title: '공지사항',
  },
  free: {
    title: '자유게시판',
  },
  event: {
    title: '대회정보',
  },
};
